import Carousel from 'react-bootstrap/Carousel';
import Button from 'react-bootstrap/Button';
import { Container } from 'react-bootstrap';


function Home() {
    return (
      <>
        <Carousel>
          <Carousel.Item interval={7500}>
            <img
              className="d-block w-100 blur"
              src="img/womens_banner.jpg"
              alt="womens_banner"
            />
            <Carousel.Caption style={{top: 150, bottom: "auto"}}>
              <h1 style={{fontSize: "300%"}}>Spoura - Womens</h1>
              <Button variant="primary" href="/womens">Shop now!</Button>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item interval={7500}>
            <img
              className="d-block w-100 blur"
              src="img/mens_banner.jpg"
              alt="mens_banner"
            />
            <Carousel.Caption style={{top: 150, bottom: "auto"}}>
              <h1 style={{fontSize: "300%"}}>Spoura - Mens</h1>
              <Button variant="primary" href="/mens">Shop now!</Button>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item interval={7500}>
            <img
              className="d-block w-100 blur"
              src="img/kids_banner.jpg"
              alt="kids_banner"
            />
            <Carousel.Caption style={{top: 150, bottom: "auto"}}>
              <h1 style={{fontSize: "300%"}}>Spoura - Kids</h1>
              <Button variant="primary" href="/kids">Shop now!</Button>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
        <main>
          <Container>
            <br></br>
            <h1>Welcome to Spoura!</h1>
            <p>Shop for the newest clothes in mens/womens/kids.</p>
          </Container>
        </main>
      </>
    );
}

export default Home;